import React from 'react';

const ArtemisArchitecture = () => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <h1 style={{ fontSize: '2.5em', marginBottom: '20px', color: '#333' }}>
        Artemis Architecture
      </h1>
      <p style={{ fontSize: '1.2em', color: '#666', marginBottom: '40px' }}>
        Understanding the core components and architecture of Artemis
      </p>
      
      <div style={{ 
        background: '#f8f9fa', 
        padding: '40px', 
        borderRadius: '12px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ fontSize: '2em', marginBottom: '30px', color: '#444' }}>
          System Architecture Overview
        </h2>
        
        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ fontSize: '1.5em', marginBottom: '20px', color: '#555' }}>
            Core Components
          </h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '20px' 
          }}>
            <div style={{ 
              background: 'white', 
              padding: '25px', 
              borderRadius: '8px',
              border: '1px solid #e0e0e0'
            }}>
              <h4 style={{ color: '#673ab7', marginBottom: '10px' }}>🧬 Genetic Algorithm Engine</h4>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                The heart of Artemis - evolves code through genetic algorithms to find optimal solutions
              </p>
            </div>
            <div style={{ 
              background: 'white', 
              padding: '25px', 
              borderRadius: '8px',
              border: '1px solid #e0e0e0'
            }}>
              <h4 style={{ color: '#673ab7', marginBottom: '10px' }}>📊 Code Analysis Module</h4>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                Analyzes code structure, performance metrics, and identifies optimization opportunities
              </p>
            </div>
            <div style={{ 
              background: 'white', 
              padding: '25px', 
              borderRadius: '8px',
              border: '1px solid #e0e0e0'
            }}>
              <h4 style={{ color: '#673ab7', marginBottom: '10px' }}>🔧 Transformation Engine</h4>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                Applies optimizations and transformations to code while maintaining functionality
              </p>
            </div>
          </div>
        </div>
        
        <div style={{ marginBottom: '40px' }}>
          <h3 style={{ fontSize: '1.5em', marginBottom: '20px', color: '#555' }}>
            Data Flow
          </h3>
          <div style={{ 
            background: 'linear-gradient(to right, #e0e0e0 0%, #e0e0e0 50%, transparent 50%)',
            backgroundSize: '20px 2px',
            backgroundRepeat: 'repeat-x',
            backgroundPosition: 'center',
            height: '100px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 20px'
          }}>
            <div style={{ 
              background: '#673ab7', 
              color: 'white', 
              padding: '15px 25px', 
              borderRadius: '8px',
              fontWeight: 'bold'
            }}>
              Input Code
            </div>
            <div style={{ 
              background: '#9c27b0', 
              color: 'white', 
              padding: '15px 25px', 
              borderRadius: '8px',
              fontWeight: 'bold'
            }}>
              Analysis
            </div>
            <div style={{ 
              background: '#ab47bc', 
              color: 'white', 
              padding: '15px 25px', 
              borderRadius: '8px',
              fontWeight: 'bold'
            }}>
              Evolution
            </div>
            <div style={{ 
              background: '#ba68c8', 
              color: 'white', 
              padding: '15px 25px', 
              borderRadius: '8px',
              fontWeight: 'bold'
            }}>
              Optimized Code
            </div>
          </div>
        </div>
        
        <div>
          <h3 style={{ fontSize: '1.5em', marginBottom: '20px', color: '#555' }}>
            Key Features
          </h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '15px', paddingLeft: '30px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: 0, color: '#673ab7' }}>✓</span>
              <strong>Language Agnostic:</strong> Works with multiple programming languages
            </li>
            <li style={{ marginBottom: '15px', paddingLeft: '30px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: 0, color: '#673ab7' }}>✓</span>
              <strong>Scalable Architecture:</strong> Handles projects of any size
            </li>
            <li style={{ marginBottom: '15px', paddingLeft: '30px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: 0, color: '#673ab7' }}>✓</span>
              <strong>Real-time Optimization:</strong> Continuous improvement during development
            </li>
            <li style={{ marginBottom: '15px', paddingLeft: '30px', position: 'relative' }}>
              <span style={{ position: 'absolute', left: 0, color: '#673ab7' }}>✓</span>
              <strong>Safety First:</strong> Maintains code correctness throughout optimization
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ArtemisArchitecture; 